<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 11.5a3 3 0 0 0 4.3 0l2.7-2.7a3 3 0 0 0-4.3-4.3l-1 1M11.5 8.5a3 3 0 0 0-4.3 0l-2.7 2.7a3 3 0 0 0 4.3 4.3l1-1"/></svg>
</template>
